import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconText = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M2.49861 11.9073L3.29008 9.7176H6.39759L7.18258 11.9073H8.73957L5.69694 4H4.04912L1 11.9073H2.49861ZM4.87952 5.36713L6.06673 8.70963H3.62095L4.82113 5.36713H4.87952Z",
        fill: "black"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.5792 11.1542H13.6311V11.9073H15V7.73642C15 6.3693 13.8647 5.69153 12.3401 5.69153C10.5107 5.69153 9.73216 6.56046 9.67377 7.60319H11.0232C11.0751 7.05865 11.5227 6.6937 12.3077 6.6937C13.1121 6.6937 13.5792 7.08182 13.5792 7.78277V8.36785H11.8406C10.2641 8.36785 9.42076 9.0572 9.42076 10.1463C9.42076 11.2875 10.3355 12 11.6654 12C12.6775 12 13.2808 11.6235 13.5792 11.1542ZM12.1001 11.021C11.4643 11.021 10.8675 10.714 10.8675 10.0768C10.8675 9.56698 11.2502 9.21361 12.0871 9.21361H13.5792V9.89138C13.5792 10.5576 12.937 11.021 12.1001 11.021Z",
        fill: "black"
    }));

export { IconText };
